import { observable } from 'mobx';
import RootStore from './root-store';

class BatchLogicStore {
  rootStore: RootStore;
  @observable loading: boolean = false;
  @observable code: string = '';

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  get api() {
    return this.rootStore.newAuthStore;
  }

  get plantId() {
    return this.rootStore.locationsStore.plantId;
  }

  async getCode(): Promise<void> {
    this.loading = true;

    try {
      const resp: any = await this.api
        .makeAuthorizedRequest(
          `/api/plant/${this.plantId}/batchLogic`);
      this.code = resp ? resp.code : '';
    } finally {
      this.loading = false;
    }
  }

  async saveCode(code: string) {
    this.loading = true;
    const url = `/api/plant/${this.plantId}/batchLogic`;
    this.api.storeDB.init().then(() => this.api.storeDB.save(url, code));

    try {
      const resp: any = await this.api
        .makeAuthorizedRequest(
          url,
          { code },
          'PUT');
      this.code = resp ? resp.code : '';
    } finally {
      this.loading = false;
    }
  }
}

export default BatchLogicStore;
